/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import IntegrationsConstants from 'constants/IntegrationsConstants'
import IntegrationsQueries from 'queries/IntegrationsQueries'

const IntegrationsStore = Marty.createStore({
  id: 'IntegrationsStore',

  getInitialState() { return {
    slackUserMapped: undefined,
    createAccessTokenState: {},
    dailiesByDate: {},
    protipsById: {},
    integrationStates: undefined,
    hubspotInjectionState: undefined,
    hubspotTimelineState: undefined,
    hubspotCookieState: undefined
  } },

  handlers: {
    mapSlackUserDone: IntegrationsConstants.MAP_SLACK_USER_DONE,
    createAccessTokenDone: IntegrationsConstants.CREATE_ACCESS_TOKEN_DONE,
    createAccessTokenFailed: IntegrationsConstants.CREATE_ACCESS_TOKEN_FAILED,
    fetchProtipDone: IntegrationsConstants.FETCH_PROTIP_DONE,
    fetchIntegrationStatesDone: IntegrationsConstants.FETCH_INTEGRATION_STATES_DONE,
    fetchHubspotInjectionStateDone: IntegrationsConstants.FETCH_HUBSPOT_INJECTION_STATE_DONE,
    fetchHubspotTimelineStateDone: IntegrationsConstants.FETCH_HUBSPOT_TIMELINE_STATE_DONE,
    fetchHubspotCookieStateDone: IntegrationsConstants.FETCH_HUBSPOT_COOKIE_STATE_DONE,
    updateIntegrationStateDone: IntegrationsConstants.UPDATE_INTEGRATION_STATE_DONE,
    updateHubspotInjectionStateDone: IntegrationsConstants.UPDATE_HUBSPOT_INJECTION_STATE_DONE,
    updateHubspotTimelineStateDone: IntegrationsConstants.UPDATE_HUBSPOT_TIMELINE_STATE_DONE,
    updateHubspotCookieStateDone: IntegrationsConstants.UPDATE_HUBSPOT_COOKIE_STATE_DONE
  },

  createAccessToken(name, body) {
    this.app.queries.IntegrationsQueries.createAccessToken(name, body)
    const createAccessTokenState = _.cloneDeep(this.state.createAccessTokenState)
    createAccessTokenState[name] = IntegrationsConstants.CREATE_ACCESS_TOKEN_STARTING
    return this.setState({ createAccessTokenState })
  },

  mapSlackUserDone(body) {
    return this.setState({ slackUserMapped: body.ok })
  },

  createAccessTokenDone(name) {
    const createAccessTokenState = _.cloneDeep(this.state.createAccessTokenState)
    createAccessTokenState[name] = IntegrationsConstants.CREATE_ACCESS_TOKEN_DONE
    return this.setState({ createAccessTokenState })
  },

  createAccessTokenFailed(name) {
    const createAccessTokenState = _.cloneDeep(this.state.createAccessTokenState)
    createAccessTokenState[name] = IntegrationsConstants.CREATE_ACCESS_TOKEN_FAILED
    return this.setState({ createAccessTokenState })
  },

  getSlackUserMappingState() {
    return this.state.slackUserMapped
  },

  getAccessTokenCreationState() {
    return this.state.createAccessTokenState
  },

  fetchProtip(id) {
    return this.fetch({
      id: `fetchProtip-${ id }`,
      locally() {
        return this.state.protipsById[id]
      },
      remotely() {
        return this.app.queries.IntegrationsQueries.fetchProtip(id)
      }
    })
  },

  fetchProtipDone(id, body) {
    const protipsById = _.cloneDeep(this.state.protipsById)
    protipsById[id] = body
    return this.setState({ protipsById })
  },

  fetchIntegrationStates() {
    return this.fetch({
      id: 'fetchIntegrationStates',
      locally() {
        return this.state.integrationStates
      },
      remotely() {
        return this.app.queries.IntegrationsQueries.fetchIntegrationStates()
      }
    })
  },

  fetchIntegrationStatesDone(body) {
    return this.setState({ integrationStates: body })
  },

  fetchHubspotInjectionStateDone(body) {
    return this.setState({ hubspotInjectionState: body })
  },

  fetchHubspotTimelineStateDone(body) {
    return this.setState({ hubspotTimelineState: body })
  },

  fetchHubspotCookieStateDone(body) {
    return this.setState({ hubspotCookieState: body })
  },

  updateIntegrationStateDone(body) {
    return this.setState({ integrationStates: body })
  },

  updateHubspotInjectionStateDone(body) {
    return this.setState({ hubspotInjectionState: body })
  },

  updateHubspotTimelineStateDone(body) {
    return this.setState({ hubspotTimelineState: body })
  },

  updateHubspotCookieStateDone(body) {
    return this.setState({ hubspotCookieState: body })
  },

  fetchHubspotInjectionState() {
    return this.fetch({
      id: 'fetchHubspotInjectionState',
      locally() {
        return this.state.hubspotInjectionState
      },
      remotely() {
        return this.app.queries.IntegrationsQueries.fetchHubspotInjectionState()
      }
    })
  },

  fetchHubspotTimelineState() {
    return this.fetch({
      id: 'fetchHubspotTimelineState',
      locally() {
        return this.state.hubspotTimelineState
      },
      remotely() {
        return this.app.queries.IntegrationsQueries.fetchHubspotTimelineState()
      }
    })
  },

  fetchHubspotCookieState() {
    return this.fetch({
      id: 'fetchHubspotCookieState',
      locally() {
        return this.state.hubspotCookieState
      },
      remotely() {
        return this.app.queries.IntegrationsQueries.fetchHubspotCookieState()
      }
    })
  }
})

export default IntegrationsStore



// WEBPACK FOOTER //
// ./src/scripts/stores/IntegrationsStore.js